module.exports = __webpack_public_path__ + "img/icon-component-label_Books.b21419ec.svg";